var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('send-email-modal'),_c('send-whatsapp-modal'),_c('confirmation-modal',{attrs:{"cancel":_vm.close,"confirm":_vm.deleteRow,"title":"Confirme exclusão de orçamento","message":"Tem certeza que deseja excluir esse orçamento?"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }